<template>
  <div>
    <div class="coupon-list-window on">
      <div class="title">
        Kupon eksklusif vip{{vip_grade}}
      </div>
      <div class="coupon-list" v-if="coupon.length > 0">
        <div class="item acea-row row-center-wrapper" style="position: relative" v-for="(item, index) in coupon"
          :key="index" @click="getCouponUser(index, item.id)">
          <!--<div class="tips" v-if="item.vip_grade!=0">vip{{item.vip_grade}}</div>-->
          <div class="money">
            {{icon_moeny}}<span class="num">{{ item.coupon_price  | MoneyFormat}}</span>
          </div>
          <div class="text">
            <div class="condition line1">
              Available with {{icon_moeny}}{{ item.use_min_price  | MoneyFormat}} purchase
              <!--购物满{{ item.use_min_price }}可用-->
            </div>
            <div class="data acea-row row-between-wrapper">
              <div>
                {{ item.start_time ? item.start_time + "-" : ""
                }}{{ item.end_time }}
              </div>
              <div class="bnt acea-row row-center-wrapper" :class="!item.is_use ? 'bg-color-red' : 'gray'">
                {{ !item.is_use ? "Collect now" : "Already owned" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--无优惠券-->
      <div class="pictrue" v-else>
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>

  </div>
</template>
<script>
  import { getCouponReceive } from "@api/user";
  export default {
    name: "VipCouponPop",
    props: {
      coupon: {
        type: Array,
        default: () => []
      },
      vip_grade: String
    },
    data: function () {
      return {
        icon_moeny: this.global.moeny,
      };
    },
    mounted: function () { },
    methods: {

      getCouponUser: function (index, id) {
        let that = this,
          list = that.coupon;
        if (list[index].is_use === true) return;
        getCouponReceive(id).then(function () {
          that.$dialog.toast({ mes: "Already owned" });
          that.$set(list[index], "is_use", true);
          that.$emit("changefun", { action: "currentcoupon", value: index });
          that.$emit("changeFun", { action: "changecoupon", value: false });
        }).catch(res => {
          that.$dialog.error("Get the failure");

        })
      }
    }
  };
</script>
<style scoped>
  .tips {
    position: absolute;
    top: 0.15rem;
    right: 0px;
    padding: 2px 4px;
    background: #ED4336;
    color: #fff;
    font-size: 0.25rem;
  }

  .coupon-list-window {
    position: relative;
  }
</style>